import * as Url from "./Utils/UrlUtil";

export function refreshTemplatePreview(templateId: number) {
    const urlTemplate: string = window.ETDR_RD.appConfig["UrlTemplate.TemplatePreview"];
    const url: string = Url.createUrlFromTemplate(urlTemplate, { templateId: templateId });
    $('#preview-document').load(url);
}
